/* template */
<template><div class="package-usage-item"><div class="package-usage-item-left"><div class="package-usage-item-left-title">{{ packDetail }}</div><div class="package-usage-item-left-time">{{ showTime }}</div></div><div class="package-usage-item-right">{{ packNum }}</div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m009b7a6c"}'>
  .package-usage-item
    padding 12px
    box-sizing border-box
    display flex
    justify-content space-between
    align-items center
    box-sizing border-box
    background #F8F9FD
    border-radius 8px
    margin-bottom 8px
    &-left
      display flex
      flex-direction column
      justify-content space-between
      font-family PingFangSC-Medium
      font-weight 500
      font-size 14px
      line-height 16px
      letter-spacing 0px
      color #333
      &-time
        font-family PingFangSC-Regular
        font-weight 400
        font-size 10px
        line-height 10px
        letter-spacing 0px
        color #000
        margin-top 4px
    &-right
      font-family PingFangSC-Regular
      font-weight 400
      font-size 14px
      line-height 16px
      letter-spacing 0px
      color #333
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m009b7a6c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./package-usage-item.mpx.js?isComponent&outputPath=components%2Fpackage-usage-item009b7a6c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./package-usage-item.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fpackage-usage-item009b7a6c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m009b7a6c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/package-usage-item009b7a6c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
